export default __webpack_public_path__ + "assets/models/6689634cc6a9fc530e82b338e1d40191.glb";